import { useContext } from 'react';
import { FacilitiesContext } from '@/context/facilitiesContext';

export const useFacilitiesContext = () => {
    const context = useContext(FacilitiesContext);
    if (!context) {
        throw new Error('useFacilitiesContext must be used within a FacilitiesContext.Provider');
    }
    return context;
}